<template lang="pug">
.wrap-property-details
  h1 {{ property.name }}
  table.property-details
    tr
      td {{ $t("property_page.property_id") }}
      td {{ property.slug }}
    tr
      td {{ $t("property_page.existing_new") }}
      td {{ propertyExisting }}
    tr
      td {{ $t("property_page.address") }}
      td {{ property.post_code }} {{ property.address_line1 }} {{ property.address_line2 }}
    tr
      td {{ $t("property_page.number_of_floors") }}
      td {{ property.floors }}
    tr
      td {{ $t("property_page.total_area") }}
      td {{ $n(property.area) }}
    tr
      td {{ $t("property_page.date_of_building") }}
      td {{ localizedDate(property.built_date) }}
    tr
      td {{ $t("property_page.property_age") }}
      td {{ property.age }}
    tr
      td {{ $t("property_page.renovation_date") }} ({{ $t("property.renovation_exterior") }})
      td {{ localizedDate(property.renovation_date_exterior) }}
    tr
      td {{ $t("property_page.renovation_date") }} ({{ $t("property.renovation_common") }})
      td {{ localizedDate(property.renovation_date_common) }}
    tr
      td {{ $t("property_page.building_structure") }}
      td {{ $t(`building_structure.${property.building_structure}`) }}
    tr
      td {{ $t("property_page.time_nearest_station") }}
      td {{ $n(property.time_nearest_station) }}

  #wrap-popover-options
    button#popover-button-options {{ $t("property_page.facilities") }}
    column-popover(
      :facilitiesData="propertyFacilities"
      field="code"
      target="popover-button-options"
      :placeholder="$t('property_page.no_facilities')"
    )

  a.modal-options(href="#" @click.prevent="showImages(property)") {{ $t('property_page.show_images') }}
  image-gallery(
    v-if="showGallery"
    :property="property",
    @closeModal="closeGallery"
  )
</template>

<script>
import ColumnPopover from '@/components/shared/column_popover'
import ImageGallery from '@/components/shared/image-gallery-modal'
import localizeDate from '@/mixins/localize-date'

export default {
  components: {
    ColumnPopover,
    ImageGallery
  },

  mixins: [localizeDate],

  props: {
    property: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      showGallery: false
    }
  },

  computed: {
    propertyExisting() {
      if (this.property.existing) {
        return this.$t('property_page.existing')
      }
      return this.$t('property_page.new')
    },
    propertyFacilities() {
      if (!this.property.facilities) {
        return []
      }
      return this.property.facilities.map(facility => {
        const locale_path = `facilities.${facility.code}`
        return { code: this.$t(locale_path) }
      })
    }
  },

  methods: {
    showImages() {
      this.showGallery = true
      document.documentElement.style.overflow = 'hidden'
    },

    closeGallery() {
      this.showGallery = false
      document.documentElement.style.overflow = 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap-property-details {
  padding-top: 2%;

  h1 {
    color: #3d4a57;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0;
    margin: 2% 0;
  }
}

.property-details {
  tr {
    background: #fcfdfe;
    box-shadow: 0 1px 0 0 #edf2f6, 0 -1px 0 0 #edf2f6;
    height: 40px;

    td {
      width: 270px;

      &:first-child {
        color: #7c91a7;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0;
      }

      &:last-child {
        color: #313541;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
      }
    }
  }

  #wrap-popover-options {
    margin: 20px 0;

    #popover-button-options {
      background-color: transparent;
      border: 0;
      color: #008bd0;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      padding: 0;
    }
  }

  .modal-options {
    color: #008bd0;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    padding: 0;
    text-decoration: none;
  }
}
</style>
